
import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
import { ITicketParams } from "../Interfaces/ticket";
@Component
export default class Ticket extends Vue {
  private count: number = 1; //人数
  private SignUpSetType: any = [];
  private currentTicket: any = {}; // 当前选中的票的数据
  private surplusTicket: number = 0; // 剩余票数
  private signUpOpts: any = {}; // 报名配置
  private flags: any = {
    settypeid: 0, //选中票的索引
    is_check: 0, //显示 ‘该票种需主办方审核’ 文案
  };

  @Prop({
    type: Object,
    default: {},
    required: true,
  })
  datas!: any;
  /**
   * @description: 将票种数据给父组件
   */
  @Emit("handleGetTicketData")
  handleGetTicketData(type: string) {
    let ticketData: ITicketParams;
    let { settypeid, money, type_name } = this.currentTicket;
    if (type == "next") {
      ticketData = {
        type,
        settypeid,
        money,
        count: this.count,
        ticketName: type_name,
      };
    } else {
      ticketData = {
        type,
      };
    }

    return ticketData;
  }
  created() {
    if (this.datas.sslDatas) {
      let { settypeid } = this.datas.sslDatas;
    }
  }
  mounted() {
    const { SignUpSetType, ...signUpOpts } = this.datas;
    if (SignUpSetType) {
      // 遍历数据 判断第几个被选中
      for (let i = 0; i < SignUpSetType.length; i++) {
        const item = SignUpSetType[i];
        if (this.isCanChoose(item)) {
          this.surplusTicket = item.surplus_population;
          this.handleChooseTicket(i, item);
          break;
        }
      }
      this.count = this.datas.ssl_count || 1;
      this.signUpOpts = signUpOpts;
    }
    if (signUpOpts.sslDatas) {
      this.flags.settypeid = signUpOpts.sslDatas.settypeid;
    }
    this.SignUpSetType = SignUpSetType;

    // console.log(this.datas, "this.SignUpSetType ", this.SignUpSetType, "signUpOpts", signUpOpts);
  }
  /**
   * @description: 查询余票
   * @param {number} settypeid 票种id
   */
  async fetchGetSurplusTicket(settypeid: string) {
    const _params = {
      m: String(this.$route.query.m),
      settypeid: Number(settypeid),
    };
    try {
      const res = await this.$http.SignUp.QuerySignRemaining(_params);
      if (res.Code === 1000) {
        this.surplusTicket = res.Count;
      } else if (res.Code === 3333) {
        this.surplusTicket = 0;
        this.currentTicket.surplus_population = 0;
      }
      // console.log("根据票种类型查询余票接口:", res);
    } catch (error) {
      console.log(error);
    }
  }
  /**
   * @description: 判断是否可以选中
   * @param {number} surplus_population 剩余人数 等于0 则不可点击
   * @param {number} headcount 总人数 等于0 则代表没有限制人数
   * @returns true 代表可以选中 false 反之
   */
  isCanChoose(item: any) {
    if (item.surplus_population === 0 && item.headcount != 0) {
      return false;
    }
    return true;
  }
  /**
   * @description: 加减人数
   * @param {string} type reduce:减 add:加
   */
  handleClickOperation(type: string) {
    const { limit_number, headcount } = this.currentTicket;
    const { count, signUpOpts, SignUpSetType } = this;
    switch (type) {
      case "add":
        //有票种，先判断票数;否则去判断限报
        if (SignUpSetType.length) {
          // 总票和该票限制人数都为0，
          if (!limit_number && !headcount) {
            this.count++;
          } else {
            // limit_number 为0 不限购
            if (!limit_number) {
              if (count < this.surplusTicket) {
                this.count++;
              }
            } else {
              // count(人数) 小于余票 和 票的限制数量
              if (!headcount) {
                if (count < limit_number) {
                  this.count++;
                }
              } else if (headcount && count < this.surplusTicket && count < limit_number) {
                this.count++;
              }
            }
          }
          // 小于 当前账户的限制数量
        } else if (count < signUpOpts.limit_population) {
          this.count++;
        }
        break;
      case "reduce":
        this.count > 1 ? this.count-- : (this.count = 1);
        break;
    }
  }
  /**
   * @description: 选择票种
   */
  handleClickChooseTicket(index: number, item: any) {
    if (!this.isCanChoose(item)) return;
    this.handleChooseTicket(index, item);
    this.count = 1;
  }

  handleChooseTicket(i: any, item: any) {
    Object.assign(this.flags, {
      settypeid: item.settypeid,
      is_check: i,
    });
    this.currentTicket = item;
    // headcount 为0 不需要查询余票
    if (item.headcount) {
      this.fetchGetSurplusTicket(item.settypeid);
    }
  }
}
